export default "__VITE_ASSET__e0e845b1__"